<template>
  <div>
    <character-select
      :selected="state.sourceCharacterKey"
      :characters="getSourceCharacters(emitter.caseConf)"
      :disabled="readonly"
      :errors="sourceCharacterErrors"
      placeholder="Select Character"
      @input="updateCharacter"
    />
    <change-answer-effect
      :readonly="!state.sourceCharacterKey"
      effect-type="AI_ANSWER"
      placeholder="Question/statement"
      :get-dialogue-items="getDialogueItems"
      :put-data="putDataWithCharacterData"
      v-bind="$props"
    />
  </div>
</template>

<script>
import get from 'lodash/get';
import nodeMixins from './mixins/NodeMixins';
import { getSourceCharacters } from '~lib/common/utils/characters';
import { getDialogueItemsForCharacter } from '~lib/common/utils/dialogue';
import { isNpc } from '~lib/common/utils/npc';
import CharacterSelect from './CharacterSelect.vue';
import ChangeAnswerEffect from './ChangeAnswerEffect.vue';

export default {
  name: 'change-npc-answer-effect',
  components: {
    CharacterSelect,
    ChangeAnswerEffect,
  },
  mixins: [ nodeMixins ],
  props: ['readonly', 'emitter', 'ikey', 'getData', 'putData', 'control', 'type'],
  data() {
    return {
      state: {
        sourceCharacterKey: null,
      },
    };
  },
  computed: {
    sourceCharacterErrors() {
      return this.getErrorsById('missingSourceCharacter');
    }
  },
  created() {
    const data = this.getData(this.ikey) || {};
    this.state.sourceCharacterKey = get(data, 'sourceCharacterKey');
    // To make legacy effects work, if we have a saved id, set selectedCharacterKey to 'patient'
    if (data.id && !data.sourceCharacterKey) {
      this.state.sourceCharacterKey = 'patient'
    }
  },
  mounted() {
    this.emitter.trigger('process', this.control);
  },
  methods: {
    // set sourceCharacterKey to patient by default if we have saved data
    updateCharacter(key) {
      this.state.sourceCharacterKey = key;
      // First time selecting a character we don't want to emit null id and cause validation errors
      if (!this.getData(this.ikey)) {
        return;
      }
      this.putDataWithCharacterData(this.ikey, {
        id: null,
      });
    },
    putDataWithCharacterData(key, data) {
      const type = isNpc(this.state.sourceCharacterKey) ? 'NPC_AI_ANSWER' : 'AI_ANSWER';
      this.putData(key, {
        ...data,
        type,
        sourceCharacterKey: this.state.sourceCharacterKey,
      });
      this.emitter.trigger('process', this.control);
    },
    getSourceCharacters,
    getDialogueItems() {
      return getDialogueItemsForCharacter(this.emitter.caseConf, this.state.sourceCharacterKey, 'aiQuestions')
    }
  },
};
</script>

<style scoped>
</style>